export default __webpack_public_path__ + "static/cfm-ai-features-poster-ffe106f89442960082c578a9c580be42.jpg";